import { useMemo } from 'react';

import { Configuration, PreferencesApi } from '@rtkwlf/notification-service';

import { fetchWithToken } from '@platform/core/auth';

import { useOrganizationContext } from '@packages/legacy/organization-context';
import { env } from '@packages/utils/env';

export const useNotificationPreferencesApi = (): PreferencesApi => {
  const { selectedOrganization: org } = useOrganizationContext();

  const url = useMemo(
    () => env.VITE_NOTIFICATION_SERVICE_BASE_PATH.replace('{{pod}}', org.pod),
    [org.pod],
  );

  return useMemo(
    () =>
      new PreferencesApi(
        new Configuration({
          basePath: url,
          fetchApi: fetchWithToken,
        }),
      ),
    [url],
  );
};
